import { notificationsConstants } from '../components/Header/header.constant';

export default {
    data() {
        return {
            notifications: [],
            notification: {
                notificationCount: 0,
            },
            toggleNotificationTools: false,
        };
    },
    methods: {
        notificationFormatter(notification) {
            let notificationTypeName = "";
            let activityItemType = "";
            let your = "";
            switch (notification.notificationTypeName) {
                case notificationsConstants.LIKES_POST:
                    notificationTypeName = notificationsConstants.SMALL_LIKES;
                    activityItemType = notificationsConstants.POST;
                    your = notificationsConstants.YOUR;
                    break;
                case notificationsConstants.LIKES_COMMENT:
                    notificationTypeName = notificationsConstants.SMALL_LIKES;
                    activityItemType = notificationsConstants.COMMENT;
                    your = notificationsConstants.YOUR;
                    break;
                case notificationsConstants.LIKES_REPLY:
                    notificationTypeName = notificationsConstants.SMALL_LIKES;
                    activityItemType = notificationsConstants.REPLY;
                    your = notificationsConstants.YOUR;
                    break;
                case notificationsConstants.REPLIES:
                    notificationTypeName = notificationsConstants.REPLIED_TO;
                    activityItemType = notificationsConstants.COMMENT;
                    your = notificationsConstants.YOUR;
                    break;
                case notificationsConstants.COMMENTS:
                    notificationTypeName = notificationsConstants.COMMENTED_ON;
                    activityItemType = notificationsConstants.POST;
                    your = notificationsConstants.YOUR;
                    break;
                case notificationsConstants.LIKES:
                    notificationTypeName = notificationsConstants.SMALL_LIKES;
                    activityItemType = notificationsConstants.POST;
                    your = notificationsConstants.YOUR;
                    break;
                case notificationsConstants.NEW_FOLLOWERS:
                    notificationTypeName = notificationsConstants.STARTED_FOLLOWING_YOU;
                    break;
                case notificationsConstants.NEW_YPO_CONNECTIONS:
                    notificationTypeName = notificationsConstants.ADDED_CONNECTION;
                    break;
                case notificationsConstants.MEMBER_MENTIONS:
                    notificationTypeName = notificationsConstants.MEMBER_MENSTIONED;
                    break;
                case notificationsConstants.NEW_CONVERSATION_POST:
                    activityItemType = notification.fromCommunityType === notificationsConstants.HOME ? notificationsConstants.NEW_CONVERSATION_POST_MESSAGE
                        : `${notificationsConstants.NEW_CONVERSATION_POST_MESSAGE} ${notificationsConstants.IN} ${notification.fromCommunityName}  `;
                    break;
                default:
                    break;
            }
            return `${notificationTypeName} ${your} ${activityItemType} `;
        },
        openLink(notification) {
            if (notification.notificationTypeName === notificationsConstants.NEW_FOLLOWERS
                || notification.notificationTypeName === notificationsConstants.NEW_YPO_CONNECTIONS
                || notification.notificationTypeName === notificationsConstants.STARTED_FOLLOWING_YOU
            ) {
                this.$router.push({
                    path: `/memberProfile?memberId=${notification.fromPersonId}`,
                });
            } else {
                this.$router.push({
                    name: notification.fromCommunityType.toLowerCase(),
                    params: {
                        communityId: notification.fromCommunityId,
                    },
                    query: {
                        postId: notification.parentPostId,
                        highlightText: '',
                        showAllActivityFeedCommunity: "true",
                    },
                });
            }
            this.toggleNotificationTools = false;
        },
    },
};
